import {ExpressionType} from 'models/MessageTypes'

export const expressionValidation = (expression: ExpressionType) => {
  return (
    !expression?.attribute?.id ||
    !(expression?.value || ['IS_DEFAULT', 'IS_NOT_DEFAULT'].includes(expression?.operator))
  )
}
